import Vue    from 'vue';

import http   from './http'
import router from './router'
import config from './config'
import i18n from './i18n'
import store  from './store'

import Vuetify from 'vuetify/lib'
Vue.use(Vuetify)

import JQuery from 'jquery'
window.$ = JQuery

import App from './components/App.vue';

import 'bootstrap'
import "./styles/global.scss"

import {MediaQueries} from 'vue-media-queries';
const mediaQueries = new MediaQueries();
Vue.use(mediaQueries);

Vue.config.productionTip = false;
new Vue({
    el: '#mainApp',
    http: http,
    store: store,
    router: router,
    config: config,
    i18n,
    vuetify: new Vuetify({
        theme: { 
            disable: true
        }
      }),
    mediaQueries: mediaQueries,
    render: h => h(App)
});